import React from 'react';
import PropTypes from 'prop-types';


const IconCollapse = ({ width = '14px', height = '12px' }) => {
    return <svg width={width} height={height} viewBox='0 0 14 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M5.5 0.5L7 2L3 6L7 10L5.5 11.5L0 6L5.5 0.5ZM12.5 0.5L14 2L10 6L14 10L12.5 11.5L7 6L12.5 0.5Z' fill='#1F1F1F' />
    </svg>;
};

IconCollapse.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default IconCollapse;
